import { useEffect, useState } from 'react';
import { PlatformType } from '../constants/common';
function useMenu(menuRef, platform) {
    const [menuName, setMenuName] = useState('');
    const [position, setPosition] = useState(0);
    const [showDropDown, setShowDropDown] = useState(false);
    const onMenuSelection = (event, menuItem) => {
        let left = event.currentTarget.offsetLeft;
        setMenuName(menuItem);
        left = menuItem === 'ProfileMenu' ? left - 95 : left;
        setPosition(left);
        if (platform === PlatformType.Tablet) {
            setShowDropDown(true);
        }
    };
    const onMenuClick = (menuItem, external, url) => {
        setTimeout(() => {
            window.open(url, external ? '_blank' : '_self');
        }, 100);
    };
    useEffect(() => {
        if (platform === PlatformType.Tablet) {
            const handleClickOutside = e => {
                if (!menuRef.current.contains(e.target)) {
                    setShowDropDown(false);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, []);
    return {
        menuName,
        setMenuName,
        position,
        setPosition,
        showDropDown,
        setShowDropDown,
        onMenuSelection,
        onMenuClick,
    };
}
export default useMenu;
